import React, { useRef, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export const ImageUpload = ({ value, onChange, label = "Thumbnail", testid = "image-upload" }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const up = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post("/creatives/upload-image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.path);
      toast.success("Image uploaded");
    } catch (err) { toast.error("Upload failed"); }
    setBusy(false);
  };

  return (
    <div>
      {label && <Label className="text-zinc-300">{label}</Label>}
      <input ref={ref} type="file" accept="image/*" onChange={up} className="hidden" data-testid={`${testid}-file`} />
      {value ? (
        <div className="mt-1.5 relative w-full">
          <img src={fileUrl(value)} alt="thumbnail" className="rounded-xl max-h-40 w-full object-cover border border-ink-700" />
          <button type="button" data-testid={`${testid}-remove`} onClick={() => onChange(null)}
            className="absolute top-2 right-2 bg-ink-900/80 rounded-full p-1.5 text-white hover:bg-red-500/80"><X className="w-4 h-4" /></button>
        </div>
      ) : (
        <Button type="button" variant="outline" onClick={() => ref.current?.click()} disabled={busy}
          data-testid={`${testid}-button`} className="mt-1.5 w-full border-ink-700 bg-ink-900 hover:bg-ink-700">
          {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />} Upload image
        </Button>
      )}
    </div>
  );
};
